import { Injectable } from '@angular/core';
import { LOGIN } from '../actions/index';
import { AuthLogoutAction, AuthSignInWithEmailAndPasswordAction } from '../actions/auth-actions';
import { Action } from '../action';
import { getLoginForm } from '../selectors';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map, mapTo, withLatestFrom } from 'rxjs/operators';

@Injectable()
export class LoginAuthEffects {
	@Effect()
	loginWithEmailAndPassword$: Observable<Action> = this.actions$.pipe(
		ofType(LOGIN.CLICK_SIGNIN),
		withLatestFrom(this.store.pipe(select(getLoginForm))),
		map(([_a, b]) => new AuthSignInWithEmailAndPasswordAction(b))
	);
	@Effect()
	logout$: Observable<Action> = this.actions$.pipe(ofType(LOGIN.CLICK_LOGOUT), mapTo(new AuthLogoutAction()));

	constructor(
		private actions$: Actions,
		private store: Store<any>
	) {}
}
